import React from "react";
import Modal from "react-modal";

import Video from "../components/Video";
import "../styles/modal.scss";
import "../styles/video-gallery.scss";

const modalStyles = {
  overlay: {
    zIndex: 1
  },
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgb(0, 0, 0)",
    overflowX: "hidden"
  }
};

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      videoId: ""
    };
  }

  onToggleModal = () => {
    this.setState({ modalIsOpen: !this.state.modalIsOpen });
    this.props.toggleAudio();
  };

  onVideoClick = id => {
    this.setState({
      videoId: id
    });

    this.onToggleModal();
  };

  render() {
    const items = this.props.data.allVideosJson.edges;
    return (
      <div className={"video-gallery"}>
        {items.map(item => (
          <Video
            data={item.node}
            onClick={this.onVideoClick}
            key={item.node.videoId}
          />
        ))}

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.onToggleModal}
          ariaHideApp={false}
          style={modalStyles}
        >
          <button
            className={"modal__close"}
            onClick={this.onToggleModal}
            aria-label="close modal"
          >
            &times;
          </button>
          <div className={"modal__video-content"}>
            <div className={"modal__video-wrapper"}>
              <iframe
                className={"modal__video"}
                src={`https://player.vimeo.com/video/${this.state.videoId}`}
                frameBorder="0"
                allowFullScreen
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export const pageQuery = graphql`
  query BuyPageQuery {
    allVideosJson {
      edges {
        node {
          videoId
          title
          client
          role
          img
        }
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js